import * as _ from 'lodash';

import { api } from '../axiosConfig';
import {messagesURL} from "../Utils/urls";

export class MessagesAPI {
    static getAll(
        limit : any,
        currentPageNumber : number,
        payload: { [key: string]: any },
        offset = 0,
        config: any = {}
    ): Promise<any[]> {
        return api.post(`${messagesURL}/getAll/${limit}/${currentPageNumber}`, payload, config).then((res) => {
            return _.get(res, 'data', []);
        });
    }

    static create(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${messagesURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOne(
        id : string
    ): Promise<any[]> {
        return api.post(`${messagesURL}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static update(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${messagesURL}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static updatebulkresolved(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${messagesURL}/updatebulkresolved`, payload)
            .then((res) => {
                return _.get(res, 'data', {});
            });
    }

    static deleteOne(id: string): Promise<any> {
        return api.post(`${messagesURL}/delete/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }
}
